export class USSDPaymentRes {
  reference: string;
  clientId: string;
  paymentUrl: string;
  status: string;
  providerResponse: string;
  providerExtraInfo: string;
}

export class CardPaymentReq {
  reference: string;
  clientId: string;
  paymentUrl: string;
  status: string;
  providerResponse: string;
}
